import {DialogTypes} from 'common/names';
import Dialog from 'components/Dialog';
import {RoiReportForm} from 'features/roi/RoiReportForm';
import React from 'react';
import {useTranslation} from 'react-i18next';

type Props = {
   // data: INav;
   onClose: () => void;
};
export const RoiReportDialog = ({onClose}: Props) => {
   const {t} = useTranslation();

   return (
      <Dialog header={DialogTypes.RoiReportDialog.dialogName} close={onClose} maxWidth="md">
         <RoiReportForm onClose={onClose} />
      </Dialog>
   );
};
